'use client';

import { Button, Group, TextInput, Textarea } from '@mantine/core';
import { isEmail, isNotEmpty, useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationMark, IconSend } from '@tabler/icons-react';
import { useState } from 'react';
import { sendEmail } from './actions';

interface FormValues {
  email: string;
  subject: string;
  message: string;
}

export default function ContactForm() {
  const [loading, setLoading] = useState(false);

  const form = useForm<FormValues>({
    initialValues: {
      email: '',
      subject: '',
      message: '',
    },
    validate: {
      email: isEmail('Invalid email'),
      subject: isNotEmpty('Please enter a subject'),
      message: isNotEmpty('Please enter a message'),
    },
  });

  const sendValues = async (values: FormValues) => {
    setLoading(true);
    const res = await fetch(`/api/email/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: values.email,
        subject: values.subject,
        message: values.message,
      }),
    });

    if (res.ok) {
      setLoading(false);
      form.reset();
      notifications.show({
        title: 'Email Received',
        message: `Thanks for reaching out! We will be in touch shortly`,
        color: 'cyan',
        icon: <IconCheck size="1rem" />,
      });
    } else {
      setLoading(false);
      notifications.show({
        title: 'An error occurred',
        message: `Please try again later`,
        color: 'red',
        icon: <IconExclamationMark size="1rem" />,
      });
    }
  };

  return (
    <form
      onSubmit={form.onSubmit((values) => sendValues(values))}
      onReset={form.onReset}
      autoComplete="off"
      action={() => sendEmail(form.values)}
    >
      <TextInput
        required
        placeholder="your@email.com"
        label="Email"
        type="email"
        {...form.getInputProps('email')}
      />
      <TextInput
        required
        placeholder="Some subject"
        label="Subject"
        type="text"
        {...form.getInputProps('subject')}
      />
      <Textarea
        required
        placeholder="Hello Invie!"
        label="Message"
        rows={2}
        {...form.getInputProps('message')}
      />
      <Group justify="flex-end">
        <Button type="submit" rightSection={<IconSend size={18} />} loading={loading} mt="sm">
          Send
        </Button>
      </Group>
    </form>
  );
}
